<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <h1 class="title text-primary text-start pb-5">Who is playing?</h1>
  <input
    v-model="firstName"
    class="form-control field no-focusborder text-start"
    type="text"
    ref="inputfield"
    placeholder="First name"
    required
  />
  <input
    v-model="lastName"
    class="form-control field no-focusborder text-start"
    type="text"
    ref="inputfield"
    placeholder="Last name"
    required
  />
  <input
    v-model="email"
    class="form-control field no-focusborder text-start"
    type="email"
    ref="inputfield"
    placeholder="Email"
    required
  />
  {{ validateEmail }}
  <input
    v-model="phone"
    class="form-control field no-focusborder text-start"
    type="text"
    ref="inputfield"
    placeholder="Phone"
    required
  />
  <input
    v-model="company"
    class="form-control field no-focusborder text-start"
    type="text"
    ref="inputfield"
    placeholder="School / Company"
    required
  />
  <div class="d-grid gap-2 pt-4">
    <button
      type="button"
      class="btn btn-secondary btn-lg mt-3"
      :disabled="isDisabled == true"
      @click="setPersonalData()"
    >
      Continue
    </button>
  </div>
</template>

<script>
export default {
  name: "PersonalDataScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    phone: null,
    email: null,
    company: null,
  }),
  computed: {
    isDisabled() {
      if (this.firstName && this.lastName && this.email && this.company) {
        return false;
      }
      return true;
    },
    validateEmail() {
      let msg;
      if (this.email !== null) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
          msg = "";
        } else {
          msg = "Please enter a valid email address";
        }
      }
      return msg;
    },
  },
  methods: {
    setPersonalData() {
      this.$store.commit("setFirstName", this.firstName);
      this.$store.commit("setLastName", this.lastName);
      this.$store.commit("setPhone", this.phone);
      this.$store.commit("setEmail", this.email);
      this.$store.commit("setCompany", this.company);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 30px;
  color: #000 !important;
  font-weight: 300;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  border-radius: 20px;
  width: 100%;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 10px;
  color: #000;
  background-color: rgba(255, 255, 255, 0.8);
}
.field::placeholder {
  color: #000;
  opacity: 0.9;
}
.btn {
  border-radius: 20px;
}
</style>
